$('.brand-image-caption a.image-link').hover(function() {
    var $overlay = $(this).find('.overlay');
    $overlay.css('background', 'rgba(0, 0, 0, 0.8)');
    $(this).find('.overlay svg path').css({
        'stroke': '#005AFF'
    });
}, function() {
    var $overlay = $(this).find('.overlay');
    $overlay.css('background', 'rgba(0, 0, 0, 0)');
    $(this).find('.overlay svg path').css({
        'stroke': '#333'
    });
})

import Swipe from 'swipejs'
import Glide from "@glidejs/glide";

function initBrandLightboxCarousel(id,perView,autoplay) {
    var lightboxGlide = new Glide('.' + id, {
        type: 'carousel',
        startAt: 0,
        perView: perView,
        gap: 0,
        animationDuration: 1000,
    });
    lightboxGlide.mount();
    var productImages = document.getElementsByClassName(id);

    let currentIndex = 0;
    lightboxGlide.on('run',function(){
        currentIndex = lightboxGlide.index;
        if(lightboxGlide.index === productImages[0].querySelectorAll('.glide__slide:not(.glide__slide--clone)').length - 1) {
            productImages[0].querySelector('.glide-nav-button.glide-next').classList.add("inactive");
            productImages[0].querySelector('.glide-nav-button.glide-prev').classList.remove("inactive");
        } else if(lightboxGlide.index === 0) {
            productImages[0].querySelector('.glide-nav-button.glide-prev').classList.add("inactive");
            productImages[0].querySelector('.glide-nav-button.glide-next').classList.remove("inactive");
        } else if(lightboxGlide.index !== (0 || productImages[0].querySelectorAll('.glide__slide:not(.glide__slide--clone)').length - 1)) {
            productImages[0].querySelector('.glide-nav-button.glide-next').classList.remove("inactive");
            productImages[0].querySelector('.glide-nav-button.glide-prev').classList.remove("inactive");
        }
        productImages[0].querySelectorAll('.navigationItem').forEach(function (item) {
            item.classList.add("inactive-link");
        });
        setTimeout(() => {   
            productImages[0].querySelectorAll('.navigationItem').forEach(function (item) {
                item.classList.remove("inactive-link");
            });
        }, 1000)
    });

    var glideNavigation = productImages[0].querySelectorAll('.navigationItem');
    productImages[0].querySelectorAll('.navigationItem').forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();

            glideNavigation.forEach(function (e) {
                e.classList.remove("active");
            });


            var dataAttribute = item.querySelector("a").getAttribute('data-id');
            item.classList.add("active");
        
            if(dataAttribute === productImages[0].querySelectorAll('.glide__slide:not(.glide__slide--clone)').length - 1) {
                productImages[0].querySelector('.glide-nav-button.glide-next').classList.add("inactive");
                productImages[0].querySelector('.glide-nav-button.glide-prev').classList.remove("inactive");
            } else if(dataAttribute === 0) {
                productImages[0].querySelector('.glide-nav-button.glide-prev').classList.add("inactive");
                productImages[0].querySelector('.glide-nav-button.glide-next').classList.remove("inactive");
            } 

            lightboxGlide.go('=' + item.querySelector("a").getAttribute('data-id'));
        });
    });

    if($(productImages[0]).find('.glide-navigation').length) {
        productImages[0].querySelector('.glide-nav-button.glide-prev').addEventListener('click', function (e) {
            e.preventDefault();

            if(currentIndex !== 0) {
                productImages[0].querySelector('.glide-nav-button.glide-prev').classList.remove("inactive");
                lightboxGlide.go('<');

                glideNavigation.forEach(function (item) {
                    if(parseInt(item.querySelector("a").getAttribute('data-id')) == currentIndex) {
                        item.classList.add("active");
                    } else {
                        item.classList.remove("active");
                    }   
                });  
            }
        });

        productImages[0].querySelector('.glide-nav-button.glide-next').addEventListener('click', function (e) {
            e.preventDefault();

            if(currentIndex !== productImages[0].querySelectorAll('.glide__slide:not(.glide__slide--clone)').length - 1) {
                lightboxGlide.go('>');

                glideNavigation.forEach(function (item) {
                    if(parseInt(item.querySelector("a").getAttribute('data-id')) === currentIndex) {
                        item.classList.add("active");
                    } else {
                        item.classList.remove("active");
                    }  
                });
            }
        });
    }
};

var animationLength = 500; // Change this in _grensesnitt-lightbox.scss as well if changed

var $grensesnittLightboxContainer = $('.gl-container');
var $navPrev = $('.gl-nav-prev > a');
var $navNext = $('.gl-nav-next > a');
var swipe;
var $lightboxesTemplates = $('.lightbox-template');

if($lightboxesTemplates.length > 0) {
    $lightboxesTemplates.click(function (e) {
        e.preventDefault();

        showLightbox();

        if (swipe) {
            swipe.kill();
            swipe = null;
        }

        var $lightboxImages = $(this).parents('#page-content').find('.lightbox-template');

        $lightboxImages.each(function (index, el) {
            var $el = $(el);
        
            $el.attr('data-index', index);
        });

        addImages($lightboxImages);

        swipe = new Swipe($('.gl-swipe')[0], {
            draggable: true,
            continuous: true,
            disableScroll: true
        });

        $grensesnittLightboxContainer[0].addEventListener('touchmove', function (e) {
            e.preventDefault();
        });

        var index = parseInt($(this).data('index')) || 0;
        swipe.slide(index, 1);
    });

    $('.gl-container .gl-close').click(function (e) {
        e.preventDefault();

        hideLightbox();
    });

    $('.gl-container .overlay').click(function(e) {
        hideLightbox();
    });

    $navNext.click(function (e) {
        e.preventDefault();

        swipe.next();

        $('.gl-container .gl-inner .gl-image .gl-swipe-wrap .download-meta .resolutions a').removeClass('active');
        $('.gl-container .gl-inner .gl-image .gl-swipe-wrap .download-meta .resolutions .resolution-wrapper .wrapper').removeClass('show');
        $('.gl-container .gl-inner .gl-image .gl-swipe-wrap .download-meta .resolutions .resolution-wrapper a.original-image').addClass('active');
        $('.gl-container .gl-inner .gl-image .gl-swipe-wrap .download-meta .resolutions .resolution-wrapper .wrapper.original').addClass('show');
    });

    $navPrev.click(function (e) {
        e.preventDefault();

        swipe.prev();

        $('.gl-container .gl-inner .gl-image .gl-swipe-wrap .download-meta .resolutions a').removeClass('active');
        $('.gl-container .gl-inner .gl-image .gl-swipe-wrap .download-meta .resolutions .resolution-wrapper .wrapper').removeClass('show');
        $('.gl-container .gl-inner .gl-image .gl-swipe-wrap .download-meta .resolutions .resolution-wrapper a.original-image').addClass('active');
        $('.gl-container .gl-inner .gl-image .gl-swipe-wrap .download-meta .resolutions .resolution-wrapper .wrapper.original').addClass('show');
    });

    function addImages($lightboxImages) {
        var $swipeWrap = $('.gl-swipe-wrap');
        $swipeWrap.html('');

        $lightboxImages.each(function (index, el) {
            var $carouselCount = el.querySelector("img").getAttribute("data-carousel");
            var $carouselImages = [];
            for(let i=0; i < $carouselCount; i++) {
                $carouselImages.push(el.querySelector("img").getAttribute(`data-image-${i + 1}`));
            }

            var url = el.href;
            var siteUrl = el.querySelector("img").getAttribute("data-site-link");
            var downloadAccess = el.querySelector("img").getAttribute('data-download-access');
            var imageName = el.querySelector("img").getAttribute('data-name');
            var imageDate = el.querySelector("img").getAttribute('data-date');
            var resPrintable = el.querySelector("img").getAttribute('data-printable-res');
            var resDigital = el.querySelector("img").getAttribute('data-digital-res');
            var resTemplate = el.querySelector("img").getAttribute('data-template-res');
            var imageDescription = el.querySelector("img").getAttribute('data-description');
            var printableFiletext = el.querySelector("img").getAttribute('data-filetext-printable');
            var digitalFiletext = el.querySelector("img").getAttribute('data-filetext-digital');
            var templateFiletext = el.querySelector("img").getAttribute('data-filetext-template');
            var printableDimensions = el.querySelector("img").getAttribute('data-dimensions-printable');
            var digitalDimensions = el.querySelector("img").getAttribute('data-dimensions-digital');
            var templateDimensions = el.querySelector("img").getAttribute('data-dimensions-template');
            var sizePrintable = makeBytesHumanReadable(el.querySelector("img").getAttribute('data-filesize-printable'));
            var sizeDigital = makeBytesHumanReadable(el.querySelector("img").getAttribute('data-filesize-digital'));
            var sizeTemplate = makeBytesHumanReadable(el.querySelector("img").getAttribute('data-filesize-template'));

            const noAccessClass = downloadAccess === true ? "no-access" : "";
            const noFilePrintable = resPrintable.length === 0 ? "no-access" : "";
            const noFileDigital = resDigital.length === 0 ? "no-access" : "";
            const noFileTemplate = resTemplate.length === 0 ? "no-access" : "";

            let activePrintable = "";
            let activeDigital = "";
            let activeTemplate = "";
            let showPrintable = "";
            let showDigital = "";
            let showTemplate = "";
            let currentFileLink = "";
            
            if(resPrintable.length > 0) {
                activePrintable = "active original-image";
                showPrintable = "show original";
                currentFileLink = resPrintable;
            } else if(resDigital.length > 0) {
                activeDigital = "active original-image";
                showDigital = "show original";
                currentFileLink = resDigital;
            } else if(resTemplate.length > 0) {
                activeTemplate = "active original-image";
                showTemplate = "show original";
                currentFileLink = resTemplate;
            };

            if($carouselImages.length > 0) {
                var $carouselItems = "";
                var navigationItem = "";
                function getRandomString(length) {
                    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                    var result = '';
                    for ( var i = 0; i < length; i++ ) {
                        result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
                    }
                    return result;
                };
                var $carouselID = getRandomString(20);

                for(let i=0; i<($carouselImages.length + 1); i++) {
                    if(i === 0) {
                        $carouselItems += `
                            <li class="glide__slide">
                                <div class="glide_image">
                                    <img src="${el.href}" />
                                </div>
                            </li>
                        `  
                    } else {
                        $carouselItems += `
                            <li class="glide__slide">
                                <div class="glide_image">
                                    <img src="${$carouselImages[i-1]}" />
                                </div>
                            </li>
                        `    
                    }   
                    
                    if(i === 0) {
                        navigationItem += `                       
                        <div class="navigationItem active"><a href="#"
                            data-id="${i}">
                            <span></span>
                        </a></div>`
                    } else {
                        navigationItem += `                       
                        <div class="navigationItem"><a href="#"
                            data-id="${i}">
                            <span></span>
                        </a></div>`
                    }
                };
                
                var carousel = `            
                    <div class="glide brand-lightbox-templates ${$carouselID.trim()}">
                        <div class="glide__track" data-glide-el="track">
                            <ul class="glide__slides">

                                ${$carouselItems}
            
                            </ul>
                        </div>
            
                        <div class="glide-navigation">
                            <a href="#" class="glide-nav-button glide-prev inactive">
                                <svg width="20px" height="14px" viewBox="0 0 20 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <title>Arrow left</title>
                                    <defs>
                                        <polygon id="path-1" points="0 0.0004 19.7496 0.0004 19.7496 13.3354 0 13.3354"></polygon>
                                    </defs>
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g transform="translate(-15.000000, -1445.000000)">
                                            <g transform="translate(25.000000, 1452.000000) scale(-1, 1) translate(-25.000000, -1452.000000) translate(15.000000, 1445.000000)">
                                                <mask id="mask-2" fill="white">
                                                    <use xlink:href="#path-1"></use>
                                                </mask>
                                                <g></g>
                                                <path d="M11.5386,13.3354 C11.4276,13.3354 11.3166,13.3114 11.2136,13.2614 C10.9536,13.1364 10.7886,12.8734 10.7886,12.5854 L10.7886,7.3764 L-0.0004,7.3764 L-0.0004,5.8764 L11.5386,5.8764 C11.9526,5.8764 12.2886,6.2114 12.2886,6.6264 L12.2886,11.0264 L17.7986,6.6264 L10.9816,1.1704 L11.9186,0.0004 L19.4686,6.0414 C19.6466,6.1834 19.7496,6.3984 19.7496,6.6274 C19.7496,6.8554 19.6456,7.0704 19.4686,7.2124 L12.0066,13.1714 C11.8716,13.2794 11.7056,13.3354 11.5386,13.3354" fill="#005AFF" mask="url(#mask-2)"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </a>

                            ${navigationItem}

                            <a href="#" class="glide-nav-button glide-next">
                                <svg width="20px" height="14px" viewBox="0 0 20 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <title>Arrow</title>
                                    <defs>
                                        <polygon id="path-1" points="0 0.0004 19.7496 0.0004 19.7496 13.3354 0 13.3354"></polygon>
                                    </defs>
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g transform="translate(-1405.000000, -1445.000000)">
                                            <g transform="translate(1405.000000, 1445.000000)">
                                                <mask id="mask-2" fill="white">
                                                    <use xlink:href="#path-1"></use>
                                                </mask>
                                                <g></g>
                                                <path d="M11.5386,13.3354 C11.4276,13.3354 11.3166,13.3114 11.2136,13.2614 C10.9536,13.1364 10.7886,12.8734 10.7886,12.5854 L10.7886,7.3764 L-0.0004,7.3764 L-0.0004,5.8764 L11.5386,5.8764 C11.9526,5.8764 12.2886,6.2114 12.2886,6.6264 L12.2886,11.0264 L17.7986,6.6264 L10.9816,1.1704 L11.9186,0.0004 L19.4686,6.0414 C19.6466,6.1834 19.7496,6.3984 19.7496,6.6274 C19.7496,6.8554 19.6456,7.0704 19.4686,7.2124 L12.0066,13.1714 C11.8716,13.2794 11.7056,13.3354 11.5386,13.3354" fill="#005AFF" mask="url(#mask-2)"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </a>
            
                        </div>
            
                    </div>`

                    $swipeWrap.append('<div><div class="image brand-templates-images">' + carousel + '</div><div class="right-content"><div class="meta-top"><h2 class="filename brand-filename">' + imageName + '</h2><div class="meta-wrapper"><div class="tags brand-description"><p class="template-p">' + imageDescription + '</p></div><div class="date template-date"><p class="title">Date</p><p>' + imageDate + '</p></div><div class="notice"><p class="title">Partner image</p><div class="wrapper"><span>NOTICE! </span>Partner images can not be shared with our dealers or others. These images are only to be used for Easee.</div></div></div></div><div class="download-meta template-download-meta"><p class="title">Choose</p><div class="resolutions"><div class="resolution-wrapper"><a class="' + activePrintable + ' ' + noFilePrintable + '" href="#" data-href="' + resPrintable + '">Printable</a><div class="wrapper ' + showPrintable + ' template-wrapper"><div class="file"><span>File: </span>' + printableFiletext + '</div><div class="dimensions"><span>Dimensions: </span>' + printableDimensions + '</div><div class="image-size"><span>Size: </span>' + sizePrintable + '</div></div></div><div class="resolution-wrapper"><a class="' + activeDigital + ' ' + noFileDigital + '" href="#" data-href="' + resDigital + '">Digital</a><div class="wrapper ' + showDigital + ' template-wrapper"><div class="file"><span>File: </span>' + digitalFiletext + '</div><div class="dimensions"><span>Dimensions: </span>' + digitalDimensions + '</div><div class="image-size"><span>Size: </span>'+ sizeDigital +'</div></div></div><div class="resolution-wrapper"><a href="#" class="' + activeTemplate + ' ' + noAccessClass + ' ' + noFileTemplate + '" data-href="' + resTemplate + '">Template</a><div class="wrapper ' + showTemplate + ' template-wrapper"><div class="file"><span>File: </span>' + templateFiletext + '</div><div class="dimensions"><span>Dimensions: </span>' + templateDimensions + '</div><div class="image-size"><span>Size: </span>' + sizeTemplate + '</div></div></div></div><a class="download-link" href="' + currentFileLink + '" download target="_blank" rel="noopener norefferer"><img src="' + siteUrl + '/images/arrow-down-blue.svg"/>Download</a></div></div></div>');
            } else {
                $swipeWrap.append('<div><div class="image"><img src="' + url + '" /></div><div class="right-content"><div class="meta-top"><h2 class="filename brand-filename">' + imageName + '</h2><div class="meta-wrapper"><div class="tags brand-description"><p class="template-p">' + imageDescription + '</p></div><div class="date template-date"><p class="title">Date</p><p>' + imageDate + '</p></div><div class="notice"><p class="title">Partner image</p><div class="wrapper"><span>NOTICE! </span>Partner images can not be shared with our dealers or others. These images are only to be used for Easee.</div></div></div></div><div class="download-meta template-download-meta"><p class="title">Choose</p><div class="resolutions"><div class="resolution-wrapper"><a class="' + activePrintable + ' ' + noFilePrintable + '" href="#" data-href="' + resPrintable + '">Printable</a><div class="wrapper ' + showPrintable + ' template-wrapper"><div class="file"><span>File: </span>' + printableFiletext + '</div><div class="dimensions"><span>Dimensions: </span>' + printableDimensions + '</div><div class="image-size"><span>Size: </span>' + sizePrintable + '</div></div></div><div class="resolution-wrapper"><a href="#" class="' + activeDigital + ' ' + noFileDigital + '" data-href="' + resDigital + '">Digital</a><div class="wrapper ' + showDigital + ' template-wrapper"><div class="file"><span>File: </span>' + digitalFiletext + '</div><div class="dimensions"><span>Dimensions: </span>' + digitalDimensions + '</div><div class="image-size"><span>Size: </span>'+ sizeDigital +'</div></div></div><div class="resolution-wrapper"><a href="#" class="' + activeTemplate + ' ' + noAccessClass + ' ' + noFileTemplate + '" data-href="' + resTemplate + '">Template</a><div class="wrapper ' + showTemplate + ' template-wrapper"><div class="file"><span>File: </span>' + templateFiletext + '</div><div class="dimensions"><span>Dimensions: </span>' + templateDimensions + '</div><div class="image-size"><span>Size: </span>' + sizeTemplate + '</div></div></div></div><a class="download-link" href="' + currentFileLink + '" download target="_blank" rel="noopener norefferer"><img src="' + siteUrl + '/images/arrow-down-blue.svg"/>Download</a></div></div></div>');
            }

            setTimeout(() => {   
                if($carouselCount.length > 0) {
                    initBrandLightboxCarousel($carouselID.trim(),1,false);  
                }
            }, 1000)
        })

        $('.gl-container .gl-inner .gl-image .gl-swipe-wrap .download-meta .resolutions a').click(function(e) {
            e.preventDefault();
            $('.gl-container .gl-inner .gl-image .gl-swipe-wrap .download-meta .resolutions a').removeClass('active');
            $(this).addClass('active');
            $('.gl-container .gl-inner .gl-image .gl-swipe-wrap .download-meta .resolutions .resolution-wrapper .wrapper').removeClass('show');
            $(this).parent().children('.wrapper').addClass('show');
            $(this).parents('.download-meta').children('.download-link').attr("href", $(this).data('href'));
        });
    }

    function hideLightbox() {
        $grensesnittLightboxContainer.removeClass('fade');
        var $overlay = $grensesnittLightboxContainer.find('.overlay');
        $overlay.css('background', 'rgba(0, 0, 0, 0)');

        setTimeout(function () {
            $grensesnittLightboxContainer.removeClass('show');
            $('body').removeClass('noscroll');
        }, animationLength);
    }

    function makeBytesHumanReadable(bytes) {
        var i = -1;
        var units = [' kB', ' MB', ' GB', ' TB'];
        do {
            bytes = bytes / 1024;
            i++;
        } while (bytes > 1024);
    
        return Math.max(bytes, 0.1).toFixed(1) + units[i];
    };

    function showLightbox() {
        $grensesnittLightboxContainer.addClass('show');
        var $overlay = $grensesnittLightboxContainer.find('.overlay');
        $overlay.css('background', 'rgba(0, 0, 0, 0.8)');

        setTimeout(function () {
            $grensesnittLightboxContainer.addClass('fade');

            setTimeout(function () {
                $('body').addClass('noscroll');
            }, animationLength);
        }, 10);
    }
}
